export default "__VITE_ASSET__BSF8AFpQ__"